import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {history, TIPO_CONVERSACION} from "../../_helpers";
import {ConsultaModal} from "../publica/utils/ConsultaModal";
import {Modal} from "react-bootstrap";

import tiendaService from "../../_services/cart/tienda.service";
import {URL_GENERAL} from "../../_services/cart/tiendaHost";
import {aplicarTema, temaGuardado} from "../../_helpers/tema";

class Footer extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {
        showConsulta: false,
        tema: temaGuardado(),
    }

    cambiarTema = () => {
        const tema = this.state.tema === "dark" ? "light" : "dark";
        aplicarTema(tema);
        this.setState({tema});
    }

    handleClose = () => {
        this.setState({showConsulta: false});
    }

    abrirModalMensaje = () => {
        this.setState({showConsulta: true});
    }

    /** En una tienda propia el pie lleva el contacto de la tienda, no el de DeAutopartes. */
    contactoTienda = (tienda) => {
        const wa = (tienda.whatsapp || "").replace(/[^0-9]/g, "");
        const ig = (tienda.instagram || "").replace(/^@/, "");
        const fb = tienda.facebook || "";
        return (
            <div className="grid-auto-fit ">
                <div>
                    <h4>{tienda.nombre}</h4>
                    {tienda.descripcion && <p>{tienda.descripcion}</p>}
                </div>
                <div>
                    <h4>CONTACTO</h4>
                    <ul className="footer__social">
                        {wa && (
                            <li>
                                <a href={"https://wa.me/" + wa} target="_blank" rel="noreferrer">
                                    <span><FontAwesomeIcon icon="fa-brands fa-whatsapp"/></span>
                                    {tienda.whatsapp}
                                </a>
                            </li>
                        )}
                        {tienda.telefono && (
                            <li>
                                <a href={"tel:" + tienda.telefono}>
                                    <span><FontAwesomeIcon icon="fa-solid fa-phone"/></span>
                                    {tienda.telefono}
                                </a>
                            </li>
                        )}
                        {tienda.emailContacto && (
                            <li>
                                <a href={"mailto:" + tienda.emailContacto}>
                                    <span><FontAwesomeIcon icon="fa-regular fa-envelope"/></span>
                                    {tienda.emailContacto}
                                </a>
                            </li>
                        )}
                        {ig && (
                            <li>
                                <a href={"https://instagram.com/" + ig} target="_blank" rel="noreferrer">
                                    <span><FontAwesomeIcon icon="fa-brands fa-instagram"/></span>
                                    @{ig}
                                </a>
                            </li>
                        )}
                        {fb && (
                            <li>
                                <a href={fb.startsWith("http") ? fb : "https://facebook.com/" + fb} target="_blank" rel="noreferrer">
                                    <span><FontAwesomeIcon icon="fa-brands fa-facebook-f"/></span>
                                    {fb.replace(/^https?:\/\/(www\.)?facebook\.com\//, "")}
                                </a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        );
    }

    render() {
        const tienda = tiendaService.actual();
        return (
            <>
                <footer className="footer">
                    <div className="container__dap">
                        {tienda ? this.contactoTienda(tienda) : (
                        <div className="grid-auto-fit ">
                            {/* <div>
                <h2>LOGO</h2>
                <ul>
                  <li>
                    
                    <a href="">Login</a>
                  </li>
                  <li>
                    
                    <a href=""> Registrarse </a>
                  </li>
                </ul>
              </div> */}
                            <div>
                                <h4>EMPRESA</h4>
                                <ul>
                                    {/* <li>
                    <a href=""> Misión</a>
                  </li>
                  <li>
                    <a href=""> Objetivos</a>
                  </li> */}
                                    <li>
                                        <a onClick={() => {
                                            history.push("/sobre-nosotros");
                                            window.scrollTo(0, 0);
                                        }}> Sobre Nosotros</a>
                                    </li>
                                    {/* <li>
                    <a href=""> FAQ</a>
                  </li> */}
                                </ul>
                            </div>
                            <div>
                                <h4>CONTACTO</h4>
                                <ul className="footer__social">
                                    <li>
                                        <a onClick={() => this.abrirModalMensaje()}>
                      <span>
                        <FontAwesomeIcon icon="fa-regular fa-envelope"/>
                      </span>
                                            Contactanos
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://instagram.com/deautopartes.ar" target="_blank">
                      <span>
                        <FontAwesomeIcon icon="fa-brands fa-instagram"/>
                      </span>
                                            @deautopartes.ar
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                      <span>
                        <FontAwesomeIcon icon="fa-brands fa-facebook-f"/>
                      </span>
                                            deautopartes
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        )}
                    </div>
                    <div className="footer__terms">
                        <div className="container__dap">
                            <div className="footer__terms-container">
                                <a onClick={() => {
                                    history.push("/terminos-condiciones");
                                    window.scrollTo(0, 0);
                                }}>Terminos de uso</a>
                                <a onClick={() => {
                                    history.push("/politica-privacidad");
                                    window.scrollTo(0, 0);
                                }}>Copyright <FontAwesomeIcon icon="fa-regular fa-copyright"/></a>
                                {tienda
                                    ? <a href={URL_GENERAL} target="_blank" rel="noreferrer">Tienda en DeAutopartes</a>
                                    : <a href="#"> Hecho por deautopartes</a>}
                                {/* Estaba en el panel de filtros, que no tiene nada que ver. */}
                                <button type="button" className="footer__tema" onClick={this.cambiarTema}>
                                    <FontAwesomeIcon icon={this.state.tema === "dark" ? "fa-solid fa-sun" : "fa-solid fa-moon"}/>
                                    {this.state.tema === "dark" ? "Modo claro" : "Modo oscuro"}
                                </button>
                            </div>
                        </div>
                    </div>
                </footer>

                <Modal size="md" show={this.state.showConsulta} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        Envianos un mensaje
                    </Modal.Header>
                    <Modal.Body>
                        <ConsultaModal
                            handleClose={this.handleClose}
                            type={TIPO_CONVERSACION.GENERAL}
                        />
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

export default Footer;
